import {Popover} from '@mantine/core';
import React, {useState} from 'react';
import {SelectDataProps} from 'shared/types/select-data';

import {
  Container,
  Input,
  OptionList,
  CheckBox,
  Active,
  Option,
  AddButtom,
  Button,
} from './styles';

interface Props {
  values?: string[];
  placeholder?: string;
  value?: string | boolean;
  handleConfirm: (value: string[]) => void;
  options: SelectDataProps[];
  search?: boolean;
  centerValue?: boolean;
  opened: boolean;
  setOpened: (opened: boolean) => void;
}

const MultiSelectFilter: React.FC<Props> = ({
  values = [],
  options,
  opened,
  setOpened,
  handleConfirm,
}) => {
  const [searchText, setSearch] = useState('');
  const [localValues, setLocalValues] = useState<string[]>(values ?? []);

  const changeLocalValues = (option: string) => {
    const isValue = localValues.find((localValue) => localValue === option);

    setLocalValues(
      isValue
        ? localValues.filter((localValue) => localValue !== isValue)
        : [...localValues, option],
    );
  };

  const labels = options.reduce<string[]>((labels, option) => {
    const isValue = values.find((localValue) => localValue === option.value);

    if (isValue) return [...labels, option.label];

    return labels;
  }, []);

  const submitValues = () => {
    handleConfirm(localValues);
    setOpened(false);
  };

  const availableOptions = options.filter(
    (option) =>
      option.label.toLocaleLowerCase().search(searchText.toLocaleLowerCase()) >=
      0,
  );

  return (
    <Popover
      closeOnClickOutside
      opened={opened}
      onClose={() => setOpened(false)}
      zIndex={1001}
      position="bottom-start"
      styles={{dropdown: {padding: 0}}}>
      <Popover.Target>
        <Button onClick={() => setOpened(true)} active={opened}>
          {labels.join(', ')}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Container full>
          <Input
            placeholder="Pesquisar"
            autoFocus
            onChange={(e) => setSearch(e.target.value)}
          />
          <OptionList>
            {availableOptions.map((option, index) => {
              const active = localValues.find(
                (localValue) => localValue === option.value,
              )
                ? true
                : false;

              return (
                <Option
                  {...{active}}
                  key={index}
                  onClick={() => changeLocalValues(option.value)}>
                  <CheckBox {...{active}}>{active && <Active />}</CheckBox>
                  {option.label}
                </Option>
              );
            })}
            <AddButtom onClick={submitValues}>Salvar</AddButtom>
          </OptionList>
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default MultiSelectFilter;
